@if (user) {
  <div id="main" [class]="sidebarService.contentSize$()">
    @if (userStore.isSuperAdmin()) {
      <app-toolbar backLink="dashboard" [toolbarItems]="toolbarItems">
      </app-toolbar>
    }
    <div class="p-5" id="content">
      <div
        class="flex justify-content-center flex-wrap h-screen align-items-stretch align-content-center gap-3">
        @for (card of cards; track $index) {
          <div
            class="p-card w-24rem flex align-self-stretch flex-column p-3 gap-5">
            <app-header
              styleClass="m-0"
              [icon]="card.icon"
              [text]="card.title"></app-header>

            <div>
              {{ card.description }}
            </div>

            <footer class="mt-auto">
              <div class="text-right">
                <p-button
                  [text]="true"
                  [rounded]="true"
                  [label]="card.linkCaption"
                  (onClick)="card.cta?.()"
                  [routerLink]="card.routerLink"
                  icon="fas fa-arrow-right"></p-button>
              </div>
            </footer>
          </div>
        }

        @if (userStore.isSuperAdmin()) {
          <div
            class="p-card w-24rem flex align-self-stretch flex-column p-3 gap-5">
            <app-header
              styleClass="m-0"
              icon="fas fa-shuffle"
              text="Kommune wechseln (Super-Admin)"></app-header>

            <div>Eine andere Kommune auswählen.</div>

            <footer class="mt-auto w-full">
              <p-dropdown
                styleClass="w-full"
                [options]="communeStore.asArray()"
                [(ngModel)]="user.commune"
                optionLabel="name"
                optionValue="_id"
                [filter]="true"
                filterBy="name"
                (onChange)="switchCommune()">
              </p-dropdown>
            </footer>
          </div>
        }
      </div>
    </div>
    <app-footer />
  </div>
  <p-sidebar
    *ngIf="routingService.showSidebarByRoute('root') as showSidebar"
    (onHide)="onOverlayClose()"
    position="right"
    [modal]="false"
    [styleClass]="'w-8'"
    [visible]="showSidebar">
    <ng-template pTemplate="header">
      <app-header
        [icon]="routingService.getEditFormOverlayIcon()"
        [text]="routingService.getEditFormOverlayHeader()"></app-header
    ></ng-template>
    <router-outlet name="bearbeiten"></router-outlet>
  </p-sidebar>
}
<p-confirmDialog></p-confirmDialog>
